/**
 * Form Validation Module
 */
export class FormValidation {
    constructor(form) {
        this.form = form;
        this.init();
    }
    init() {
        this.form.addEventListener('submit', (e) => {
            if (!this.validate()) {
                e.preventDefault();
            }
        });
        this.form.querySelectorAll('input, select, textarea').forEach((field) => {
            field.addEventListener('blur', () => this.validateField(field));
        });
    }
    validate() {
        let isValid = true;
        this.form.querySelectorAll('input, select, textarea').forEach((field) => {
            if (!this.validateField(field)) {
                isValid = false;
            }
        });
        return isValid;
    }
    validateField(field) {
        const value = field.value.trim();
        const isRequired = field.hasAttribute('required');
        const type = field.type;
        const minLength = parseInt(field.getAttribute('minlength') || '0');
        this.clearError(field);
        if (isRequired && !value) {
            this.showError(field, 'This field is required');
            return false;
        }
        if (value && type === 'email' && !this.isValidEmail(value)) {
            this.showError(field, 'Please enter a valid email');
            return false;
        }
        if (value && minLength && value.length < minLength) {
            this.showError(field, `Minimum ${minLength} characters required`);
            return false;
        }
        return true;
    }
    isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    showError(field, message) {
        field.classList.add('is-invalid');
        const errorEl = document.createElement('span');
        errorEl.className = 'form-error';
        errorEl.textContent = message;
        field.parentElement?.appendChild(errorEl);
    }
    clearError(field) {
        field.classList.remove('is-invalid');
        field.parentElement?.querySelector('.form-error')?.remove();
    }
}
export default FormValidation;
